import PropTypes from 'prop-types';

const AgentItem = props => {
  const {
    data: {
      agencyName,
      firstName,
      lastName,
      address,
      city,
      province,
      zipCode,
      phone,
      email
    },
    className
  } = props;

  return (
    <div className={className}>
      <div className="agent-item">
        <h3 className="title-5">{agencyName}</h3>

        <ul className="info-list">
          {props.data.hasOwnProperty('firstName') && (
            <li className="info-item">
              {firstName}, {lastName}
            </li>
          )}
          <li className="info-item">{address}</li>
          <li className="info-item offset">
            {city}, {province}, {zipCode}
          </li>
          {props.data.hasOwnProperty('phone') && (
            <li className="info-item">Phone: {phone}</li>
          )}
          {props.data.hasOwnProperty('email') && (
            <li className="info-item">E-mail: {email}</li>
          )}
        </ul>
      </div>
    </div>
  );
};

AgentItem.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string
};

AgentItem.defaultProps = {
  data: {}
};

export default AgentItem;
